export default function WilMutationObserver(fn, option) {
  const target = document.body || document;
  const defaultOption = {
    attributes: !0,
    childList: !0,
    subtree: !0
  };
  const callBacks = [fn];

  const observerHandle = function (mutationRecords) {
    mutationRecords.forEach(mutationRecord => {
      callBacks.forEach(fn => {
        fn(mutationRecord);
      });
    });
  };

  const observer = new MutationObserver(observerHandle);
  observer.observe(target, Object.assign({}, defaultOption, option));
  return observer;
}